import { render } from "./Account.vue?vue&type=template&id=415bfd7c"
import script from "./Account.vue?vue&type=script&lang=js"
export * from "./Account.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/cloud-builder-challenge-frontend/cloud-builder-challenge-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__